export default {
  namespaced: true,

  getters: {
    leiaAtiva(_, getters, rootState) {
      const empresa = rootState.empresas.find(item => item.isDefault);
      return Number(empresa?.botConfig?.leia_ativa) === 1;
    },
  },

  actions: {
    async carregarConfigsEmpresas({ commit, rootState }, http) {
      const configs = await Promise.all(rootState.empresas.map(async (empresa) => {
        const response = await http.get('chatbot/config/' + empresa.key);
        return {
          id_empresa: empresa.id_empresa,
          botConfig: {
            leia_ativa: response.data.leia_ativa,
            recusar_ligacoes: response.data.recusar_ligacoes,
            msg_recusa_ligacao: response.data.msg_recusa_ligacao,
          },
        };
      }));

      const empresas = rootState.empresas.map((empresa) => ({
        ...empresa,
        botConfig: configs.find((config) => String(config.id_empresa) === String(empresa.id_empresa)).botConfig,
      }));
      commit('SET_EMPRESAS', empresas, { root: true });
    },

    atualizarConfigEmpresa({ commit, rootState }, { idEmpresa, config }) {
      const empresas = rootState.empresas.map((empresa) => String(empresa.id_empresa) === String(idEmpresa)
        ? { ...empresa, botConfig: { ...empresa.botConfig, ...config } }
        : empresa);
      commit('SET_EMPRESAS', empresas, { root: true });
      localStorage.setItem('empresas', JSON.stringify(empresas));
    },

  },
};
